import { render, staticRenderFns } from "./flashIcon.vue?vue&type=template&id=05c4cb4a&"
import script from "./flashIcon.vue?vue&type=script&lang=js&"
export * from "./flashIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports